<template>
   <CollapseCard title="Gross Receipts" ident="tax-returns">
      <b-table
         id="table-study-periods"
         :fields="fields"
         :items="displayPeriods"
         sort-by="startDate"
      >
         <template #cell(timePeriod)="data">
            {{ data.item.label }}
         </template>
         <template #cell(action)="data">
            <div class="cell-w-buttons d-flex justify-content-end">
               <b-button variant="primary" size="sm" @click="viewTaxReturn(data.item.id)"
                  >View</b-button
               >
            </div>
         </template>
      </b-table>
      <TaxReturnEditModal
         ref="taxReturnModal"
         :company-id="company.id"
         @afterClose="refreshGrossReceiptPeriods"
      />
   </CollapseCard>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TaxReturnEditModal from '@/views/common/widgets/TaxReturnEditModal.vue';

export default {
   name: 'TaxReturnCard',
   components: {TaxReturnEditModal},

   computed: {
      ...mapGetters({
         company: 'companies/currentCompany',
         activeStudy: 'companies/activeStudy',
      }),
      ...mapGetters('taxReturn', ['taxReturnPeriods']),

      companyId() {
         return this.company?.id || null;
      },

      activeStudyId() {
         return this.activeStudy?.id || null;
      },

      displayPeriods() {
         return this.taxReturnPeriods || [];
      },

      fields() {
         return [{key: 'timePeriod'}, {key: 'action', label: ''}];
      },
   },

   watch: {
      companyId() {
         this.refreshGrossReceiptPeriods();
      },
      activeStudyId() {
         this.refreshGrossReceiptPeriods();
      },
   },

   mounted() {
      this.refreshGrossReceiptPeriods();
   },

   methods: {
      ...mapActions('taxReturn', ['loadTaxReturnData']),

      async refreshGrossReceiptPeriods() {
         if (!this.companyId || !this.activeStudyId) {
            this.$store.commit('taxReturn/clear');
            return;
         }

         try {
            await this.loadTaxReturnData({
               companyId: this.companyId,
               studyId: this.activeStudyId,
            });
         } catch (error) {
            console.error('Error loading gross receipt periods:', error);
         }
      },

      viewTaxReturn(periodId) {
         this.$refs.taxReturnModal.show(periodId);
      },
   },
};
</script>

<style scoped lang="scss"></style>
